import { combineReducers } from 'redux';
import listWidget from './matches/listWidget';
import read from './matches/read';

export default combineReducers({
    listWidget,
    read
});



// WEBPACK FOOTER //
// ./src/reducers/app/onSite/matches.js